module.exports = __webpack_public_path__ + "static/media/accessory10.f116b130.webp";